import { Link } from 'react-router-dom';
const ValidationComplete = ({ handleUploadMoreFiles, type }) => {
  const config = {
    timestamp: {
      message: 'Your files have been stamped',
      buttonText: 'Stamp results',
      linkTo: '/stamps',
    },
    verification: {
      message: 'Your files have been verified',
      buttonText: 'Verification results',
      linkTo: '/verifications',
    },
  };

  const { message, buttonText, linkTo } = config[type] || config.verification;

  return (
    <section className="flex flex-col justify-between items-start inline-flex w-[424px] h-[540px] p-10 rounded-3xl bg-black text-white ">
      <div className="self-stretch grow shrink basis-0 flex-col justify-center items-center flex">
        <div
          className="flex flex-col h-full w-full items-center justify-center gap-4 
      opacity-0 translate-y-10 animate-slide-in-up"
        >
          <div className="w-20 h-20 relative">
            <div className="w-20 h-20 left-0 top-0 absolute" />
            <div data-svg-wrapper className="left-[8.33px] top-[8.33px] absolute">
              <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.0833 46.045L49.545 23.5834L46.6408 20.7309L27.0833 40.3209L17.2116 30.4492L14.3908 33.3017L27.0833 46.045ZM32.0058 63.6667C27.6603 63.6667 23.5658 62.8356 19.7225 61.1734C15.8791 59.5112 12.5183 57.2414 9.63998 54.3642C6.76165 51.487 4.49081 48.1275 2.82748 44.2859C1.1647 40.4448 0.333313 36.3514 0.333313 32.0059C0.333313 27.6259 1.16442 23.5089 2.82665 19.655C4.48887 15.8012 6.75859 12.4489 9.63581 9.59837C12.513 6.74782 15.8725 4.49087 19.7141 2.82754C23.5553 1.16476 27.6486 0.333374 31.9941 0.333374C36.3741 0.333374 40.4911 1.16448 44.345 2.82671C48.1989 4.48893 51.5511 6.74476 54.4016 9.59421C57.2522 12.4437 59.5091 15.7945 61.1725 19.6467C62.8353 23.4989 63.6666 27.6148 63.6666 31.9942C63.6666 36.3398 62.8355 40.4342 61.1733 44.2775C59.5111 48.1209 57.2553 51.4817 54.4058 54.36C51.5564 57.2384 48.2055 59.5092 44.3533 61.1725C40.5011 62.8353 36.3853 63.6667 32.0058 63.6667Z"
                  fill="#4FE3C1"
                />
              </svg>
            </div>
          </div>
          <p className="self-stretch text-center text-[22px] font-medium  leading-[30.80px]">
            {message}
          </p>
        </div>
        <div className="self-stretch h-28 flex-col justify-start items-start gap-4 flex">
          <Link
            to={linkTo}
            className="btn-primary bg-minima-orange-2023 hover:bg-minima-orange-light text-black cursor-pointer"
          >
            {buttonText}
          </Link>
          <button
            onClick={() => {
              handleUploadMoreFiles();
            }}
            className="btn-primary bg-c-black-c-2023 hover:bg-core-black-contrast"
          >
            Upload more files
          </button>
        </div>
      </div>
    </section>
  );
};
export default ValidationComplete;
